import { Component, OnInit } from '@angular/core';
import { IonUtilititesService } from '../../services/ion-utilities/ion-utilitites.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
})
export class TermsComponent implements OnInit {

  items = [
    "In order to create a verified account or use Make Shaadi application you must be atleast 21 years old.",
    "Your use of this app represents that you have the right to enter into this Agreement and to abide by all Terms and Conditions of the same.",
    "This app is not meant to encourage any inappropriate behavior, if Make Shaadi come across someone who is engaged in such behavior his/her membership will be terminated without any refund or liability.",
    "We expect you to provide accurate information and recent pictures.",
    "Make Shaadi is not responsible for any event taking place while communicating with other members on our platform, whatever happens post communication is beyond our control and we won't be liable for the same.",
    "This agreement will remain in full force while you use the app."
  ]

  constructor(private _ion: IonUtilititesService) { }

  ngOnInit() { }

  close() {
    this._ion.modalController.dismiss();
  }

}
